import { Component } from '@angular/core';
import { Division, DivisionStatus } from 'src/shared/api';
import { FormConfig, CustomFormAccessor } from '../form-cva.component';
import { NgControl, FormBuilder } from '@angular/forms';
import { buildArrayFromEnum } from 'src/shared/utilities/utility-functions';

export const divisionFormConfig: FormConfig<Required<Division>> = {
	id: [''],
	name: [''],
	status: [DivisionStatus.Active],
	isAssignedToAJob: [''],
	subdivisions: [[]],
};

@Component({
	selector: 'rpshared-division',
	templateUrl: './division.component.html',
	styleUrls: ['./division.component.css'],
})
export class DivisionComponent extends CustomFormAccessor<Division> {
	// Constants
	readonly divisionStatuses = buildArrayFromEnum(DivisionStatus);

	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, divisionFormConfig);
	}

	// model --> view
	writeValue(value: Division): void {
		super.writeValue(value);
	}

	// view --> model
	registerOnChange(fn: (value: Division) => void) {
		super.registerOnChange(fn);
	}
}
